export const Bullet = () => '\u2022';
